@file:OptIn(InternalResourceApi::class)

package com.flowyride.feature.navigation.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.flowyride.feature.navigation.resources/"

@delegate:ResourceContentHash(-1_104_963_413)
internal val Res.string.arrival_time: StringResource by lazy {
      StringResource("string:arrival_time", "arrival_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 40),
      ))
    }

@delegate:ResourceContentHash(-2_089_334_876)
internal val Res.string.arrived_close: StringResource by lazy {
      StringResource("string:arrived_close", "arrived_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51, 33),
      ))
    }

@delegate:ResourceContentHash(-2_043_701_193)
internal val Res.string.arrived_summary: StringResource by lazy {
      StringResource("string:arrived_summary", "arrived_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 85, 71),
      ))
    }

@delegate:ResourceContentHash(1_040_304_239)
internal val Res.string.arrived_title: StringResource by lazy {
      StringResource("string:arrived_title", "arrived_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157, 53),
      ))
    }

@delegate:ResourceContentHash(-798_418_203)
internal val Res.string.camera_ahead: StringResource by lazy {
      StringResource("string:camera_ahead", "camera_ahead", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 266, 40),
      ))
    }

@delegate:ResourceContentHash(470_860_235)
internal val Res.string.camera_ahead_limit: StringResource by lazy {
      StringResource("string:camera_ahead_limit", "camera_ahead_limit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211, 54),
      ))
    }

@delegate:ResourceContentHash(-1_438_906_913)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307, 26),
      ))
    }

@delegate:ResourceContentHash(912_679_663)
internal val Res.string.guidance_unavailable: StringResource by lazy {
      StringResource("string:guidance_unavailable", "guidance_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 334, 92),
      ))
    }

@delegate:ResourceContentHash(-1_990_513_547)
internal val Res.string.location_denied: StringResource by lazy {
      StringResource("string:location_denied", "location_denied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 427, 103),
      ))
    }

@delegate:ResourceContentHash(1_308_835_594)
internal val Res.string.location_retry: StringResource by lazy {
      StringResource("string:location_retry", "location_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 531, 34),
      ))
    }

@delegate:ResourceContentHash(-2_046_154_531)
internal val Res.string.maneuver_arrive: StringResource by lazy {
      StringResource("string:maneuver_arrive", "maneuver_arrive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 687, 35),
      ))
    }

@delegate:ResourceContentHash(2_026_457_644)
internal val Res.string.maneuver_arrive_rejoin: StringResource by lazy {
      StringResource("string:maneuver_arrive_rejoin", "maneuver_arrive_rejoin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 566, 62),
      ))
    }

@delegate:ResourceContentHash(-1_212_462_679)
internal val Res.string.maneuver_arrive_start: StringResource by lazy {
      StringResource("string:maneuver_arrive_start", "maneuver_arrive_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 629, 57),
      ))
    }

@delegate:ResourceContentHash(-1_001_620_589)
internal val Res.string.maneuver_bear_left: StringResource by lazy {
      StringResource("string:maneuver_bear_left", "maneuver_bear_left", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 723, 50),
      ))
    }

@delegate:ResourceContentHash(710_841_910)
internal val Res.string.maneuver_bear_right: StringResource by lazy {
      StringResource("string:maneuver_bear_right", "maneuver_bear_right", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 774, 51),
      ))
    }

@delegate:ResourceContentHash(-411_194_551)
internal val Res.string.maneuver_exit_left: StringResource by lazy {
      StringResource("string:maneuver_exit_left", "maneuver_exit_left", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 826, 50),
      ))
    }

@delegate:ResourceContentHash(1_301_267_948)
internal val Res.string.maneuver_exit_right: StringResource by lazy {
      StringResource("string:maneuver_exit_right", "maneuver_exit_right", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 877, 51),
      ))
    }

@delegate:ResourceContentHash(-569_670_856)
internal val Res.string.maneuver_ferry: StringResource by lazy {
      StringResource("string:maneuver_ferry", "maneuver_ferry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 929, 42),
      ))
    }

@delegate:ResourceContentHash(157_194_827)
internal val Res.string.maneuver_follow_route: StringResource by lazy {
      StringResource("string:maneuver_follow_route", "maneuver_follow_route", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 972, 53),
      ))
    }

@delegate:ResourceContentHash(1_252_726_472)
internal val Res.string.maneuver_keep_left: StringResource by lazy {
      StringResource("string:maneuver_keep_left", "maneuver_keep_left", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1026, 50),
      ))
    }

@delegate:ResourceContentHash(-1_329_778_325)
internal val Res.string.maneuver_keep_right: StringResource by lazy {
      StringResource("string:maneuver_keep_right", "maneuver_keep_right", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1077, 51),
      ))
    }

@delegate:ResourceContentHash(-565_320_276)
internal val Res.string.maneuver_merge: StringResource by lazy {
      StringResource("string:maneuver_merge", "maneuver_merge", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1129, 54),
      ))
    }

@delegate:ResourceContentHash(-1_310_049_404)
internal val Res.string.maneuver_roundabout_any: StringResource by lazy {
      StringResource("string:maneuver_roundabout_any", "maneuver_roundabout_any", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1184, 51),
      ))
    }

@delegate:ResourceContentHash(-1_433_145_641)
internal val Res.string.maneuver_roundabout_plain: StringResource by lazy {
      StringResource("string:maneuver_roundabout_plain", "maneuver_roundabout_plain", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1236, 69),
      ))
    }

@delegate:ResourceContentHash(-600_935_997)
internal val Res.string.maneuver_sharp_left: StringResource by lazy {
      StringResource("string:maneuver_sharp_left", "maneuver_sharp_left", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1306, 67),
      ))
    }

@delegate:ResourceContentHash(1_407_787_499)
internal val Res.string.maneuver_sharp_right: StringResource by lazy {
      StringResource("string:maneuver_sharp_right", "maneuver_sharp_right", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1374, 68),
      ))
    }

@delegate:ResourceContentHash(444_061_958)
internal val Res.string.maneuver_straight: StringResource by lazy {
      StringResource("string:maneuver_straight", "maneuver_straight", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1443, 53),
      ))
    }

@delegate:ResourceContentHash(-1_895_862_577)
internal val Res.string.maneuver_turn_left: StringResource by lazy {
      StringResource("string:maneuver_turn_left", "maneuver_turn_left", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1497, 50),
      ))
    }

@delegate:ResourceContentHash(112_860_919)
internal val Res.string.maneuver_turn_right: StringResource by lazy {
      StringResource("string:maneuver_turn_right", "maneuver_turn_right", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1548, 51),
      ))
    }

@delegate:ResourceContentHash(1_253_113_633)
internal val Res.string.maneuver_u_turn: StringResource by lazy {
      StringResource("string:maneuver_u_turn", "maneuver_u_turn", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1600, 47),
      ))
    }

@delegate:ResourceContentHash(-1_014_401_046)
internal val Res.string.maneuver_waypoint: StringResource by lazy {
      StringResource("string:maneuver_waypoint", "maneuver_waypoint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1648, 33),
      ))
    }

@delegate:ResourceContentHash(1_849_506_681)
internal val Res.string.north_up: StringResource by lazy {
      StringResource("string:north_up", "north_up", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1682, 32),
      ))
    }

@delegate:ResourceContentHash(997_473_906)
internal val Res.string.off_route: StringResource by lazy {
      StringResource("string:off_route", "off_route", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1876, 41),
      ))
    }

@delegate:ResourceContentHash(-1_367_604_787)
internal val Res.string.off_route_no_network: StringResource by lazy {
      StringResource("string:off_route_no_network", "off_route_no_network", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1715, 80),
      ))
    }

@delegate:ResourceContentHash(35_808_994)
internal val Res.string.off_route_searching: StringResource by lazy {
      StringResource("string:off_route_searching", "off_route_searching", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1796, 79),
      ))
    }

@delegate:ResourceContentHash(-1_574_085_747)
internal val Res.string.overview: StringResource by lazy {
      StringResource("string:overview", "overview", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1918, 28),
      ))
    }

@delegate:ResourceContentHash(-1_419_896_701)
internal val Res.string.preparing_guidance: StringResource by lazy {
      StringResource("string:preparing_guidance", "preparing_guidance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1947, 62),
      ))
    }

@delegate:ResourceContentHash(1_158_269_681)
internal val Res.string.recenter: StringResource by lazy {
      StringResource("string:recenter", "recenter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2010, 28),
      ))
    }

@delegate:ResourceContentHash(-2_117_243_037)
internal val Res.string.rejoining: StringResource by lazy {
      StringResource("string:rejoining", "rejoining", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2039, 53),
      ))
    }

@delegate:ResourceContentHash(-725_192_519)
internal val Res.string.remaining: StringResource by lazy {
      StringResource("string:remaining", "remaining", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2093, 33),
      ))
    }

@delegate:ResourceContentHash(995_014_642)
internal val Res.string.resume: StringResource by lazy {
      StringResource("string:resume", "resume", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2127, 26),
      ))
    }

@delegate:ResourceContentHash(660_154_938)
internal val Res.string.simulation: StringResource by lazy {
      StringResource("string:simulation", "simulation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2154, 34),
      ))
    }

@delegate:ResourceContentHash(165_550_615)
internal val Res.string.speed_unit: StringResource by lazy {
      StringResource("string:speed_unit", "speed_unit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2189, 26),
      ))
    }

@delegate:ResourceContentHash(-2_087_733_817)
internal val Res.string.stop: StringResource by lazy {
      StringResource("string:stop", "stop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2361, 24),
      ))
    }

@delegate:ResourceContentHash(-2_087_733_817)
internal val Res.string.stop_confirm: StringResource by lazy {
      StringResource("string:stop_confirm", "stop_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2275, 32),
      ))
    }

@delegate:ResourceContentHash(1_833_916_203)
internal val Res.string.stop_confirm_title: StringResource by lazy {
      StringResource("string:stop_confirm_title", "stop_confirm_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2216, 58),
      ))
    }

@delegate:ResourceContentHash(-849_034_452)
internal val Res.string.stop_reached: StringResource by lazy {
      StringResource("string:stop_reached", "stop_reached", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2308, 52),
      ))
    }

@delegate:ResourceContentHash(-1_511_073_421)
internal val Res.string.then: StringResource by lazy {
      StringResource("string:then", "then", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2386, 20),
      ))
    }

@delegate:ResourceContentHash(71_072_791)
internal val Res.string.to_start: StringResource by lazy {
      StringResource("string:to_start", "to_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2407, 44),
      ))
    }

@delegate:ResourceContentHash(1_331_681_307)
internal val Res.string.waiting_gps: StringResource by lazy {
      StringResource("string:waiting_gps", "waiting_gps", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2452, 47),
      ))
    }

@delegate:ResourceContentHash(998_140_203)
internal val Res.string.zoom_in: StringResource by lazy {
      StringResource("string:zoom_in", "zoom_in", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2500, 23),
      ))
    }

@delegate:ResourceContentHash(1_780_093_657)
internal val Res.string.zoom_out: StringResource by lazy {
      StringResource("string:zoom_out", "zoom_out", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2524, 28),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("arrival_time", Res.string.arrival_time)
  map.put("arrived_close", Res.string.arrived_close)
  map.put("arrived_summary", Res.string.arrived_summary)
  map.put("arrived_title", Res.string.arrived_title)
  map.put("camera_ahead", Res.string.camera_ahead)
  map.put("camera_ahead_limit", Res.string.camera_ahead_limit)
  map.put("cancel", Res.string.cancel)
  map.put("guidance_unavailable", Res.string.guidance_unavailable)
  map.put("location_denied", Res.string.location_denied)
  map.put("location_retry", Res.string.location_retry)
  map.put("maneuver_arrive", Res.string.maneuver_arrive)
  map.put("maneuver_arrive_rejoin", Res.string.maneuver_arrive_rejoin)
  map.put("maneuver_arrive_start", Res.string.maneuver_arrive_start)
  map.put("maneuver_bear_left", Res.string.maneuver_bear_left)
  map.put("maneuver_bear_right", Res.string.maneuver_bear_right)
  map.put("maneuver_exit_left", Res.string.maneuver_exit_left)
  map.put("maneuver_exit_right", Res.string.maneuver_exit_right)
  map.put("maneuver_ferry", Res.string.maneuver_ferry)
  map.put("maneuver_follow_route", Res.string.maneuver_follow_route)
  map.put("maneuver_keep_left", Res.string.maneuver_keep_left)
  map.put("maneuver_keep_right", Res.string.maneuver_keep_right)
  map.put("maneuver_merge", Res.string.maneuver_merge)
  map.put("maneuver_roundabout_any", Res.string.maneuver_roundabout_any)
  map.put("maneuver_roundabout_plain", Res.string.maneuver_roundabout_plain)
  map.put("maneuver_sharp_left", Res.string.maneuver_sharp_left)
  map.put("maneuver_sharp_right", Res.string.maneuver_sharp_right)
  map.put("maneuver_straight", Res.string.maneuver_straight)
  map.put("maneuver_turn_left", Res.string.maneuver_turn_left)
  map.put("maneuver_turn_right", Res.string.maneuver_turn_right)
  map.put("maneuver_u_turn", Res.string.maneuver_u_turn)
  map.put("maneuver_waypoint", Res.string.maneuver_waypoint)
  map.put("north_up", Res.string.north_up)
  map.put("off_route", Res.string.off_route)
  map.put("off_route_no_network", Res.string.off_route_no_network)
  map.put("off_route_searching", Res.string.off_route_searching)
  map.put("overview", Res.string.overview)
  map.put("preparing_guidance", Res.string.preparing_guidance)
  map.put("recenter", Res.string.recenter)
  map.put("rejoining", Res.string.rejoining)
  map.put("remaining", Res.string.remaining)
  map.put("resume", Res.string.resume)
  map.put("simulation", Res.string.simulation)
  map.put("speed_unit", Res.string.speed_unit)
  map.put("stop", Res.string.stop)
  map.put("stop_confirm", Res.string.stop_confirm)
  map.put("stop_confirm_title", Res.string.stop_confirm_title)
  map.put("stop_reached", Res.string.stop_reached)
  map.put("then", Res.string.then)
  map.put("to_start", Res.string.to_start)
  map.put("waiting_gps", Res.string.waiting_gps)
  map.put("zoom_in", Res.string.zoom_in)
  map.put("zoom_out", Res.string.zoom_out)
}
